import { Link } from "react-router-dom";
import { Copy, Download, ArrowUpRight } from "lucide-react";
import { toast } from "sonner";
import { BACKEND_URL, imageUrl } from "@/lib/api";

export default function GalleryCard({ image, index = 0 }) {
  const fullUrl = `${BACKEND_URL}${imageUrl(image.id)}`;

  const copyUrl = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(fullUrl);
      toast.success("URL copied", { description: image.id });
    } catch {
      toast.error("Copy failed");
    }
  };

  const download = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const res = await fetch(fullUrl);
    const blob = await res.blob();
    const blobUrl = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = `${image.id}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
    toast.success("Downloaded", { description: `${image.id}.png` });
  };

  return (
    <Link
      to={`/image/${image.id}`}
      data-testid={`gallery-card-${index}`}
      className="relative group block break-inside-avoid mb-6 bg-white border-2 border-black overflow-hidden focus:outline-none focus-visible:ring-4 focus-visible:ring-[#FF3333] focus-visible:ring-offset-2"
    >
      <img
        src={fullUrl}
        alt={image.prompt}
        loading="lazy"
        className="w-full h-auto block"
      />

      {/* Top-left badge */}
      <div className="absolute top-3 left-3 flex items-center gap-2">
        <span className="label-eyebrow bg-white border-2 border-black px-2 py-1">
          {image.model === "openai" ? "GPT-IMAGE-1" : "NANO-BANANA"}
        </span>
      </div>

      {/* Hover actions */}
      <div
        data-testid={`gallery-card-actions-${index}`}
        className="absolute bottom-0 left-0 right-0 p-3 flex gap-2 bg-white/95 backdrop-blur-md border-t-2 border-black translate-y-full group-hover:translate-y-0 transition-transform duration-200"
      >
        <button
          type="button"
          onClick={copyUrl}
          data-testid={`copy-url-${index}`}
          className="flex-1 flex items-center justify-center gap-2 px-3 py-2 border-2 border-black bg-white hover:bg-black hover:text-white label-eyebrow transition-colors"
        >
          <Copy className="w-3.5 h-3.5" />
          Copy URL
        </button>
        <button
          type="button"
          onClick={download}
          data-testid={`download-${index}`}
          className="flex-1 flex items-center justify-center gap-2 px-3 py-2 border-2 border-black bg-[#FF3333] text-white hover:bg-black label-eyebrow transition-colors"
        >
          <Download className="w-3.5 h-3.5" />
          Download
        </button>
        <span
          className="flex items-center justify-center w-10 h-10 border-2 border-black bg-white"
          aria-hidden
        >
          <ArrowUpRight className="w-4 h-4" />
        </span>
      </div>
    </Link>
  );
}
